import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MarketplaceItem } from './models/marketplace-item.model';

export interface MarketplaceState extends EntityState<MarketplaceItem> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'marketplace', idKey: 'Id', cache: { ttl: 20000 } })
export class MarketplaceStore extends EntityStore<MarketplaceState> {
  constructor() {
    super();
  }

  akitaPreAddEntity(item: MarketplaceItem) {
    const newItem = { ...item, ItemImageURL: item.ItemImageURL || item.ImageURL } as MarketplaceItem;
    return newItem;
  }

  akitaPreUpdateEntity(_: MarketplaceItem, updatedItem: MarketplaceItem) {
    const newItem = { ...updatedItem, ItemImageURL: updatedItem.ItemImageURL || updatedItem.ImageURL } as MarketplaceItem;
    return newItem;
  }
}
